"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var BB8ModalTypes;

(function (BB8ModalTypes) {
  BB8ModalTypes[BB8ModalTypes["Success"] = 1] = "Success";
  BB8ModalTypes[BB8ModalTypes["Warning"] = 2] = "Warning";
  BB8ModalTypes[BB8ModalTypes["Error"] = 3] = "Error";
  BB8ModalTypes[BB8ModalTypes["Info"] = 4] = "Info";
})(BB8ModalTypes = exports.BB8ModalTypes || (exports.BB8ModalTypes = {}));

var BB8ModalSizes;

(function (BB8ModalSizes) {
  BB8ModalSizes["Default"] = "default";
  BB8ModalSizes["Medium"] = "medium";
  BB8ModalSizes["Small"] = "small";
})(BB8ModalSizes = exports.BB8ModalSizes || (exports.BB8ModalSizes = {}));